import { SurgeryStatus } from 'domain/entities/surgery-status'

export default function getActualSurgeryStatus(
  status: SurgeryStatus[]
): SurgeryStatus {
  return status.filter((register) => register.isConcluded).slice(-1)[0]
}
